import React from "react";

const SexySpin = ({
  size = 6,
  borderColor = "border-gray-500",
  fillColor = "border-white",
  speed = "animate-spin",
}) => {
  const sizeClass = typeof size === "number" ? `w-${size} h-${size}` : size;

  return (
    <div className={`${sizeClass} relative ${speed}`}>
      {/* Base circle border */}
      <div
        className={`absolute inset-0 ${borderColor} border-2 rounded-full`}
      />

      {/* Rotating quarter border section */}
      <div
        className={`absolute inset-0 rounded-full border-2 border-transparent`}
        style={{
          borderTopColor: fillColor.includes("border-")
            ? `rgb(${
                fillColor.includes("white")
                  ? "255 255 255"
                  : fillColor.includes("blue")
                  ? "59 130 246"
                  : fillColor.includes("red")
                  ? "239 68 68"
                  : fillColor.includes("green")
                  ? "34 197 94"
                  : fillColor.includes("purple")
                  ? "147 51 234"
                  : fillColor.includes("orange")
                  ? "249 115 22"
                  : fillColor.includes("pink")
                  ? "236 72 153"
                  : "59 130 246"
              })`
            : fillColor,
        }}
      />
    </div>
  );
};
export default SexySpin;
